import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../../ui/Icon";

const OperatorAccessLogsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="h-screen-dvh bg-gray-50 flex flex-col">
      {/* 상단 헤더 */}
      <header className="bg-white px-4 py-3 flex items-center justify-between border-b border-gray-200">
        <div className="flex items-center">
          <button
            onClick={() => navigate("/operator/dashboard")}
            className="mr-3 text-gray-600 hover:text-gray-800"
          >
            <Icon name="chevronLeft" size="md" />
          </button>
          <h1 className="text-lg font-medium text-gray-800">
            개인정보 접속기록 조회
          </h1>
        </div>
      </header>

      {/* 메인 콘텐츠 */}
      <main className="flex-1 overflow-y-auto p-6 flex items-center justify-center">
        <div className="max-w-md w-full bg-white rounded-lg shadow-sm p-12 text-center">
          <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Icon name="activity" className="text-blue-600" size="xl" />
          </div>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            개인정보 접속기록 조회
          </h2>
          <p className="text-gray-600 text-sm mb-6 leading-relaxed">
            시스템 접속 기록 및 활동 로그를 조회하는 기능입니다.
            <br />
            현재 준비 중이며, 곧 제공될 예정입니다.
          </p>
        </div>
      </main>
    </div>
  );
};

export default OperatorAccessLogsPage;
